/**
 * AddSupplierWrapper
 *
 * Purpose:
 * - Wraps the supplier add/edit screen to keep vendor context.
 * - Reads returnTab/returnSubTab from URL and redirects back to vendor pages.
 * - If invoked from vendor orders create PO flow (returnTo=create-po), returns to create PO with preserved tab.
 */
import React from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import AddSupplier from '../suppliers/add-supplier';
import { VENDOR, VENDOR_LIST, VENDOR_ORDERS, CREATE_PURCHASE_ORDER } from '../../constants/route-paths';
import { VENDOR_STATUS, VENDOR_TAB, VENDOR_URL_PARAM } from '../../constants/vendor.contant';

function AddSupplierWrapper(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    
    // Get return tab parameters from URL using hook
    const returnTab = searchParams.get(VENDOR_URL_PARAM.RETURN_TAB) || VENDOR_TAB.SUPPLIERS;
    const returnSubTab = searchParams.get(VENDOR_URL_PARAM.RETURN_SUB_TAB) || VENDOR_STATUS.ACTIVE;
    const returnTo = searchParams.get('returnTo');

    // Override the history prop to redirect to vendor list
    const customHistory = (dest, options) => {
        if (location.state?.returnTo) {
            navigate(location.state.returnTo, options || {
                state: {
                    ...location.state,
                    openUploadCostModal: true
                }
            });
        } else if (returnTo === 'create-po') {
            navigate(`/${VENDOR}/${VENDOR_ORDERS}/${CREATE_PURCHASE_ORDER}?${VENDOR_URL_PARAM.TAB}=${returnTab}`);
        } else {
            navigate(`/${VENDOR}/${VENDOR_LIST}?${VENDOR_URL_PARAM.TAB}=${returnTab}&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}`);
        }
    };

    const handleClose = () => {
        if (location.state?.returnTo) {
            navigate(location.state.returnTo, {
                state: {
                    ...location.state,
                    openUploadCostModal: true
                }
            });
        } else if (returnTo === 'create-po') {
            navigate(`/${VENDOR}/${VENDOR_ORDERS}/${CREATE_PURCHASE_ORDER}?${VENDOR_URL_PARAM.TAB}=${returnTab}`);
        } else {
            navigate(`/${VENDOR}/${VENDOR_LIST}?${VENDOR_URL_PARAM.TAB}=${returnTab}&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}`);
        }
    };

    // Pass through all props from RBAC (including writePermission)
    return <AddSupplier 
        {...props} 
        history={customHistory} 
        handleClose={handleClose} 
    />;
}

export default AddSupplierWrapper;
